/* ============================================================
   SOLVEY · sitebrede bundel (P1.4b, 2026-10-05)
   ------------------------------------------------------------
   Was drie losse scripts op elke pagina. Elk onderdeel is de
   oorspronkelijke code, in een eigen try/catch.
   ============================================================ */
(function () {
  function mod(name, on, fn) {
    if (!on) return;
    try { fn(); } catch (e) { if (window.console) console.error('[solvey-site] ' + name, e); }
  }

  /* ---- interaction — was solvey-interaction.js; laadstatus van de winkelwagenknop ---- */
  mod('interaction', true, function () {
    (function () {
      'use strict';

      var ATC = '[data-add-to-cart]';

      function knoppenIn(form) {
        var lijst = form ? form.querySelectorAll(ATC) : [];
        // De sticky koopbalk staat buiten het formulier maar hoort wel mee.
        return Array.prototype.slice.call(lijst);
      }

      function bezig(btn) {
        btn.classList.add('loading');
        btn.setAttribute('aria-busy', 'true');
      }

      function klaar(btn) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
      }

      function resetAlles() {
        Array.prototype.forEach.call(document.querySelectorAll(ATC), klaar);
      }

      /* Delegatie op document = bubble-fase, dus we draaien ná elke listener
         die op het formulier zelf zit. Daardoor kunnen we betrouwbaar zien of
         iemand de submit heeft afgevangen. */
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('[data-product-form]')) return;

        /* Vangt het thema (of een app) de submit alsnog af, dan komt er geen
           paginawissel en regelt die code zijn eigen state. Niet dubbelop. */
        if (e.defaultPrevented) return;

        var knoppen = knoppenIn(form);
        if (!knoppen.length) return;
        knoppen.forEach(bezig);

        /* Vangnet. Blijft de navigatie uit — geblokkeerde POST, offline,
           een app die later alsnog preventDefault doet — dan staat de knop
           anders voorgoed te draaien. */
        setTimeout(resetAlles, 8000);
      });

      /* ⚠️ Browser-back haalt de pagina uit de bfcache precies zoals hij was:
         mét .loading en aria-busy. De knop is dan onklikbaar terwijl de
         bezoeker denkt dat hij gewoon terug is. `pageshow` met persisted=true
         is het enige signaal dat je daarvoor krijgt; een gewone load-listener
         vuurt niet. visibilitychange vangt het tabblad-terugkeer-geval. */
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) resetAlles();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') resetAlles();
      });
    })();
  });

  /* ---- footer-logo-mover — was footer-logo-mover.js ---- */
  mod('footer-logo-mover', true, function () {
    (function () {
      'use strict';

      function moveLogo() {
        var logo = document.querySelector('[class*="footer-logo-logo_"]');
        var leftCol = document.querySelector('[class*="footer-left-"]');
        if (!logo || !leftCol) return;
        if (logo.getAttribute('data-solvey-logo-moved') === '1') return;
        if (leftCol.contains(logo)) {
          logo.setAttribute('data-solvey-logo-moved', '1');
          return;
        }
        leftCol.insertBefore(logo, leftCol.firstChild);
        logo.setAttribute('data-solvey-logo-moved', '1');
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', moveLogo);
      } else {
        moveLogo();
      }

      var debounceTimer = null;
      var observer = new MutationObserver(function () {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(moveLogo, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    })();
  });

  /* ---- language-switcher — was solvey-language-switcher.js ---- */
  mod('language-switcher', true, function () {
    (function () {
      'use strict';

      function closeAll(exception) {
        document.querySelectorAll('[data-solvey-lang-switch]').forEach(function (root) {
          if (root === exception) return;
          setOpen(root, false);
        });
      }

      function setOpen(root, open) {
        root.classList.toggle('is-open', open);
        var trigger = root.querySelector('[data-solvey-lang-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function toggle(root) {
        var willOpen = !root.classList.contains('is-open');
        closeAll(root);
        setOpen(root, willOpen);
      }

      function attach(root) {
        if (root.dataset.solveyLangInit === '1') return;
        root.dataset.solveyLangInit = '1';

        var trigger = root.querySelector('[data-solvey-lang-trigger]');
        if (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggle(root);
          });
          trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggle(root);
            } else if (e.key === 'Escape') {
              setOpen(root, false);
            }
          });
        }

        root.querySelectorAll('.solvey-lang-switch__option.is-active').forEach(function (opt) {
          opt.addEventListener('click', function (e) {
            e.preventDefault();
            setOpen(root, false);
          });
        });
      }

      function attachAll() {
        document.querySelectorAll('[data-solvey-lang-switch]').forEach(attach);
      }

      function init() {
        attachAll();

        // Outside click closes all open switchers.
        document.addEventListener('pointerdown', function (e) {
          document.querySelectorAll('[data-solvey-lang-switch].is-open').forEach(function (root) {
            if (!root.contains(e.target)) setOpen(root, false);
          });
        }, true);

        // Scroll / resize close.
        var closeOnScroll = function () { closeAll(null); };
        window.addEventListener('scroll', closeOnScroll, { passive: true });
        window.addEventListener('resize', closeOnScroll);

        // Escape closes + returns focus.
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          document.querySelectorAll('[data-solvey-lang-switch].is-open').forEach(function (root) {
            setOpen(root, false);
            var trigger = root.querySelector('[data-solvey-lang-trigger]');
            if (trigger && typeof trigger.focus === 'function') trigger.focus();
          });
        });

        // Re-attach if header re-renders (sticky transitions clone DOM in some themes).
        var obs = new MutationObserver(function () { attachAll(); });
        if (document.body) obs.observe(document.body, { childList: true, subtree: true });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
  });
})();
